
import { makeAutoObservable } from 'mobx'
import { makePersistable } from 'mobx-persist-store'

interface PerformancePlusData {
  performancePlusActive: boolean
  performancePlusTracking: boolean
}

export class PerformancePlusStore implements PerformancePlusData {
  performancePlusActive!: boolean
  performancePlusTracking!: boolean

  constructor() {
    this.reset()
    makeAutoObservable(this, {}, { autoBind: true })
    makePersistable(this, {
      name: `${AIS_STORE}-PerformancePlus`,
      properties: ['performancePlusActive', 'performancePlusTracking']
    })
  }

  reset() {
    this.performancePlusActive = true
    this.performancePlusTracking = true
  }

  setPerformancePlusActive(value: boolean) { this.performancePlusActive = value }
  setPerformancePlusTracking(value: boolean) { this.performancePlusTracking = value }
}
